import React, { useEffect, useState } from 'react'
import LoaderData from './loader.js'
import { useTranslation } from 'react-i18next'
import './Loader.css'
import logo from '../../assets/aakashlogo-colored.svg'
const Loder = (props) => {
    const { t } = useTranslation()
    let count = 0,
        interval = 0
    const [index, setIndex] = useState(0)
    useEffect(() => {
        setInterval(() => {
            count === 0
                ? (interval = count)
                : count === 1
                ? (interval = 3)
                : (interval = 6)
            setIndex(interval)
            if (count >= 0 && count <= 2) {
                count++
            } else {
                count = 0
            }
        }, 1000)
    }, [])
    return (
        <div className="loader_new">
            <div className="new_loder_div">
                <div className="aakash_logo2">
                    <img src={logo} />
                </div>
                <article className="title">
                    <p className="color">{props.title1}</p>
                    <p className="color2">{t('Please wait')}</p>
                    <p className="color3">
                        {props.title2}
                        <br />
                        {props.title3}
                    </p>
                    {/* <p className="color4">{props.title4}</p> */}
                </article>
                <div className="main_container">
                    <img
                        className="imageLoader"
                        src={`${LoaderData[index].p}`}
                    ></img>
                    <img
                        className="imageLoader"
                        src={`${LoaderData[index + 1].p}`}
                    ></img>
                    <img
                        className="imageLoader"
                        src={`${LoaderData[index + 2].p}`}
                    ></img>
                </div>
                <div className="progress_container">
                    <div className="progress-bar">
                        <div
                            className="loading"
                            style={{ width: `${props.done}%` }}
                        ></div>
                    </div>
                </div>
                <div className="title2">
                    {props.done}% {t('Completed')}
                </div>
                <div className="color4">{props.title4}</div>
            </div>
        </div>
    )
}
export default Loder
